import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { DomainService } from '@vendasta/domain';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const PartnerCenterDomainDemo = 'https://partner-central-demo.appspot.com';
const PartnerCenterDomainProd = 'https://partners.vendasta.com';

@Injectable({ providedIn: 'root' })
export class PartnerDomainService {
  constructor(
    private domainService: DomainService,
    private environmentService: EnvironmentService,
  ) {}

  private getIdentifier(partnerId: string): string {
    return `/application/partner-center/partner/${partnerId}`;
  }

  private getDefaultDomain(): string {
    const env = this.environmentService.getEnvironment();
    switch (env) {
      case Environment.PROD:
        return PartnerCenterDomainProd;
      default:
        return PartnerCenterDomainDemo;
    }
  }

  public getDomain(partnerId: string): Observable<string> {
    const identifier = this.getIdentifier(partnerId);
    return this.domainService.getDomainByIdentifier(identifier).pipe(
      map((resp) => {
        const domain = resp?.primary?.domain;
        if (domain) {
          const protocol = resp.primary.secure ? 'https' : 'http';
          return `${protocol}://${domain}`;
        }
        return this.getDefaultDomain();
      }),
      catchError(() => of(this.getDefaultDomain())),
    );
  }
}
